/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { Box, HStack, Text, Tooltip } from '@chakra-ui/react';
import { CQReactTable, usePagination, useToastr, useBoolean } from '@laxmimanogna/code-quick-components';

import { createColumnHelper } from '@tanstack/react-table';
import useCQMediaQuery from '../../../hooks/useCQMediaQuery';

import {
  defaultReactTableProp,
  paginationProps,
} from '../../../utils/payor_contract.utils';
import AppColors from '../../../constants/AppColors';
import payorContractsRepository from '../../../repositories/PayorContractRepository';
import { toTitleCase } from '../../../utils/common.utils';
import { format } from 'date-fns';
import FileViewAction from '../../assigned_audits/components/FileViewAction';

const columnHelper = createColumnHelper();

const AccountPayorContractSection = (props) => {
  const [payorContracts, setPayorContracts] = useState([]);
  const payorContractPagination = usePagination(getUploadedPayorContract);
  const [IsLoadingGetPayorContract, setIsLoadingGetPayorContract] = useBoolean(false)
  const toast = useToastr();
  const { queryParam } = props;

  async function getUploadedPayorContract(paginationParams){
    try {
      setIsLoadingGetPayorContract.on()
        const response = await payorContractsRepository.getUploadedPayorContract({
          ...paginationParams,
          ...queryParam,
        });
        setPayorContracts(response.results);
        return response;
    } catch (error) {
        toast.showError({
            description: `${error.toString()}`,
          });
    } finally{
      setIsLoadingGetPayorContract.off()
    }
    }

  useEffect(() => {
    payorContractPagination.loadAPI("Payor Contract", "Payor Contract Table")
  }, []);
  // media query
  const canScroll = useCQMediaQuery({
    lg: false,
    md: false,
    sm: true,
  });

  const renderActionComponent = auditUpload => {
    return (
        <HStack>
            <FileViewAction auditUpload={auditUpload} />
        </HStack>
    )
    }

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        id: 'name',
        header: () => 'Name',
        enableSorting: false,
        cell: info => {
          const cellValue = info.getValue();
          return (
            <Tooltip label={cellValue} hasArrow placement="top">
              <Text
                maxW="200px"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                fontWeight="bold"
                color={AppColors.secondary}
                mt="2"
              >
                {toTitleCase(cellValue)}
              </Text>
            </Tooltip>
          );
        },
      }),
      columnHelper.accessor('uploaded_by', {
        id: 'uploaded_by',
        header: () => <span>Uploaded by</span>,
        enableSorting: false,
        cell: info => {
          const cellValue = info.getValue();
          if (!cellValue) {
            return 'n/a';
          }

          return (
            <Text fontWeight={'normal'} color={AppColors.secondary}>
              {cellValue}
            </Text>
          );
        },
      }),
      columnHelper.accessor('upload_date', {
        id: 'upload_date',
        header: () => <span>Upload Date</span>,
        enableSorting: false,
        cell: info => {
          const cellValue = info.getValue();
          if (cellValue === null) {
            return 'n/a';
          }

          return format(new Date(cellValue), 'MM/dd/yyyy')
        },
      }),
      columnHelper.accessor('actions', {
        header: '',
        enableSorting: false,
        cell: info => {
          return renderActionComponent({file_obj:info.row.original});
        },
      }),
    ],
    [IsLoadingGetPayorContract]
  );

  function handlePreviousPage() {
    payorContractPagination.loadPrevious("Payor Contract", "Payor Contract Table");
  }

  function handleNextPage() {
    payorContractPagination.loadNext("Payor Contract", "Payor Contract Table");
  }
  
  return (
    <React.Fragment>
          <Text fontSize={'lg'} fontWeight={'bold'}>Payor Contract</Text>
      <Box
        // pointerEvents={isUpdating ? 'none' : 'inherit'}
        // overflowX={canScroll ? 'scroll' : 'inherit'}
        bg="white" p={4} w="100%" h="150%" borderRadius="md" ml={0}
      >
        <CQReactTable
          isLoading={IsLoadingGetPayorContract}
          data={payorContracts}
          columns={columns}
          {...defaultReactTableProp}
          {...paginationProps(payorContractPagination)}
          onPreviousPage={handlePreviousPage}
          onNextPage={handleNextPage}
        />
      </Box>
    </React.Fragment>
  );
};
export default AccountPayorContractSection;
